import React from "react";
import titleLogo from "../images/title_logo.png";
import { Link } from "react-router-dom";

const Header = ({ selectedMenu }) => {
  return (
    <header className="fixed top-0 left-0 right-0 h-[50px] md:h-[70px] flex items-center justify-between w-[100%] px-[18px] md:px-[36px] mx-auto bg-white z-40 max-w-[900px] min-w-[320px]">
      <Link to="/" className="flex items-center">
        <img
          src={titleLogo}
          alt="로고"
          className="w-[85px] md:w-[105px]"
        />
      </Link>
      <div className="flex gap-5">
        <Link
          to="/"
          className={`inline-block text-base md:text-lg cursor-pointer ${
            selectedMenu === 0
              ? "text-[#FF931D] font-semibold"
              : "text-black font-normal"
          }`}
        >
          아기
        </Link>
        <Link
          to="/story/question"
          className={`inline-block text-base md:text-lg cursor-pointer ${
            selectedMenu === 1
              ? "text-[#FF931D] font-semibold"
              : "text-black font-normal"
          }`}
        >
          스토리
        </Link>
        <Link
          to="/shopping"
          className={`inline-block text-base md:text-lg cursor-pointer ${
            selectedMenu === 2
              ? "text-[#FF931D] font-semibold"
              : "text-black font-normal"
          }`}
        >
          맘잉쇼핑
        </Link>
        <Link
          to="/mypage"
          className={`inline-block text-base md:text-lg cursor-pointer ${
            selectedMenu === 3
              ? "text-[#FF931D] font-semibold"
              : "text-black font-normal"
          }`}
        >
          마이
        </Link>
      </div>
    </header>
  );
};

export default Header;
